import React from 'react';

function String() {
    return (
        <>
            <div className='string h-[160px] w-[100%] -bg-[blue]'>

                <svg className='-bg-[red]' viewBox="0 0 1200 160" xmlns="http://www.w3.org/2000/svg">
                    <path d="M 10 80 Q 600 80 1180 80" stroke="black" fill="transparent" />
                </svg>

            </div>
        </>
    );
}

export default String;
